var BaseViews = require('./base');
require('./click-blocker-modal/click-blocker-modal.scss');

var ClickBlockerModal = BaseViews.LayoutView.extend({
    className: 'fmcy-click-blocker-modal fmcy-plugin-bootstrap',
    template: require('./click-blocker-modal/click-blocker-modal.html'),
    initialize: function(options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                theme: 'dark',
                _appChannel: null
            }
        );
    },
    _onWindowResize: function (event) {
      this.$el.width($(window).width());
      this.$el.height($(window).height());
    },
    onRender: function() {
      var self = this;
      this._onWindowResize();
      $(window).on('resize.' + this.cid, _.bind(this._onWindowResize, this));
      BaseViews.LayoutView.prototype.onRender.call(self);
    },
    onDestroy: function () {
      $(window).off('resize.' + this.cid);
      BaseViews.LayoutView.prototype.onDestroy.call(this);
    }
});

module.exports = ClickBlockerModal;



/** WEBPACK FOOTER **
 ** ./assets/js/common/click-blocker-modal.js
 **/